import Countries from 'i18n-iso-countries'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            /*
            countries: [
                { text: 'Česko', value: 'CZE' },
                { text: 'European Union', value: 'EUR' },
                { text: 'United States of America', value: 'USA' },
                { text: 'Other', value: 'OTHER' },
            ]
            */
        }
    },
    computed: {
        countries() {
            return Object.entries(Countries.getNames(this.locale.substring(0,2), {select: "official"})).map(([k,v]) => ({ text: v, value: k}));
        },
        ...mapState('ui', ['locale'])
    },
    methods: {
    },
    created() {
        Countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
        Countries.registerLocale(require("i18n-iso-countries/langs/cs.json"));
        //console.debug('countries', Countries.getNames(this.locale.substring(0,2), {select: "official"}))
    }
}